export const htmlToPlainText = (html) => {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  div.querySelectorAll('li').forEach(li => li.prepend(document.createTextNode('- ')));
  div.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode('\n')));
  return (div.innerText || div.textContent || '').trim().replace(/\n{3,}/g, '\n\n');
};

export const getTicketFieldValue = (ticket, field, overrides) => {
  if (overrides) {
    const ov = overrides[field];
    if (ov !== undefined && ov !== null) {
      if (field === 'summary' && typeof ov === 'string') return ov;
      if (field === 'description') {
        if (typeof ov === 'string') return ov;
        if (typeof ov === 'object' && ov.suggested) return ov.suggested;
      }
      if (field === 'labels') {
        if (Array.isArray(ov)) return ov.join(', ');
      }
    }
  }
  if (field === 'summary') return ticket?.summary || '';
  if (field === 'description') return htmlToPlainText(ticket?.descriptionHtml);
  if (field === 'labels') return (ticket?.labels || []).join(', ') || '';
  return '';
};

export const extractSuggestedChanges = (execution, ticket, { pendingOnly = false } = {}) => {
  const artStructured = execution?.artifacts?.analysis?.structured;
  if (!artStructured) return [];
  const actual = artStructured.analysis?.structured || artStructured;
  const suggestedChanges = actual.suggestedChanges;

  if (!suggestedChanges || suggestedChanges.length === 0) return [];

  const overrides = ticket?.localOverrides || {};

  const mapped = suggestedChanges.map((c, i) => {
    const hasOverride = overrides[c.field] !== undefined && overrides[c.field] !== null;
    const status = hasOverride ? 'accepted' : (c.status || 'pending');

    return {
      id: c.id || `change-${i}-${c.field}`,
      field: c.field,
      original: (ticket ? getTicketFieldValue(ticket, c.field, overrides) : '') || c.original,
      suggested: c.suggested,
      reasoning: c.reasoning,
      status
    };
  });

  if (pendingOnly) {
    return mapped.filter(c => c.status === 'pending');
  }

  return mapped;
};
